import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../_common/_service/authentication.service';
import { AuthService } from '../../_common/_service/authservice.service';
import { EncrDecrService } from '../../_common/_service/EncrDecrService.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TokenStorageService } from '../../_common/_service/token-storage.service';
import { EmailDialogComponent } from '../popup/email-dialog/email-dialog.component';
import { KycComponent } from '../popup/kyc/kyc.component';
import { OtpverificationComponent } from '../popup/otpverification/otpverification.component';
import { CommonService, CartService, CommonService2 } from "../../_common/_service/user.service";
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { ConfirmPasswordDialogComponent } from '../popup/confirm-password-dialog/confirm-password-dialog.component';
import { MerchantdocDialogComponent } from '../popup/merchantdoc/merchantdoc.component';
import { delay } from 'q';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatMenuTrigger, MatMenuPanel } from '@angular/material/menu';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-goonComponent',
  templateUrl: './goon.component.html',
  styleUrls: ['./goon.component.scss']
})

export class goonComponent implements OnInit {
  selected: any;
  showSubmenu: boolean = false;

  isLoggedIn = false;
  currentUser: any;
  username?: string;
  servicename?: string;
  MobileNo: any;
  IsdCode: any;
  EmailId: any;
  serviceId: any;
  ServiceCountryList: any;
  mobileotpstatus: any;
  kycstatus: any;
  emailConfirmed: any;
  decrypted: any;
  token: any;
  OptionList: any;
  interval?: number;
  slides = [{ 'image': '../../../../assets/Images/payservice1.jpg' },
  { 'image': '../../../../assets/Images/payservice2.jpg' },
  { 'image': '../../../../assets/Images/payservice3.jpg' },
  { 'image': '../../../../assets/Images/payservice4.jpg' },
  { 'image': '../../../../assets/Images/payservice5.jpg' },
  { 'image': '../../../../assets/Images/payservice6.jpg' }

  ];
  loadingspinner: boolean = false;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    nav: true,


    navText: ['', ''],
    responsive: {
      0: {
        items: 3
      },
      400: {
        items: 3
      },
      740: {
        items: 5
      },
      940: {
        items: 5
      }
    },
  }

  @ViewChild('matRef')
  matRef!: MatSelect;

  name: any = [];
  subCategories: any = [];

  pages: any = [];

  serviceList: any = [];
  public newArr: any = [];


  check1: any = [];
  public check2: any = [];

  @ViewChild("submenu") submenu!: MatMenuPanel;

  
  CourseamtList: string[] = ['Remove Filter','100', '200', '500', '1000', '2000', '5000','10000'];
  
  
  
  
  
  
  
  constructor(
    private toastr: ToastrService, private tokenStorageService: TokenStorageService,
    private tokenService: AuthenticationService, private _cartservice: CartService,
    public dialog: MatDialog, private authService: AuthService, private EncrDecr: EncrDecrService, private router: Router, private _service: CommonService) {

    this.tokenStorageService.getEmployeeDetail2().subscribe(data => {

      if (data != "") {
        this.currentUser = data

      }
      else {
        this.currentUser = this.tokenStorageService.getUser();

      }
    });
  }



  ngOnInit(): void {

    this.interval = 5;
    this.token = this.tokenStorageService.getToken();

    //this.currentUser = this.tokenStorageService.getUser();

    if (this.token) {

      this._cartservice.callMethodOfSecondComponent();
      this.getOptionList();
      this.getCatgories();

    }
    else {
      this.tokenService.updateMessagewithouttoken(this.currentUser);
      this.currentUser = this.tokenStorageService.getUser();

    }

  }

  getOptionList() {
    this.currentUser = this.tokenStorageService.getUser();
    this.loadingspinner = true;
    this.authService.getOptionList().subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {

      this.loadingspinner = false;
      if (response.apiStatus == true) {


        this.OptionList = response.apiData;

      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      this.loadingspinner = false;
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }



  pages2: any = [];
  newArr2: any = [];

  filterSoucategories(menuTrigger: MatMenuTrigger, Id: any) {


    //this.subCategories = this.name.subCategories;
    //var method3 = this.pages.filter((item: any) => item.id == id);
    this.check1 = [];
    this.newArr = [];
    this.newArr = this.pages.flat(1);

    //this.newArr.filter((item: any) => item.id == 5);

    this.newArr.forEach((x: any) => {

      if (x.ParentId == Id) {

        this.check1.push(x);


      }

    });

    menuTrigger.openMenu();
  }

  
  filterSubcategories(Id: any, x: any) {


    this.check2 = [];
    this.pages2 = [];

    var data = this.check1.filter((item: any) => item.Id == Id);

    this.serviceList = data[0]["SubCategories"];

    this.pages2.push(this.serviceList);


    //this.subCategories = this.name.subCategories;
    //var method3 = this.pages.filter((item: any) => item.id == id);
    //this.newArr2 = [];
    this.newArr2 = this.pages2.flat(1);

    //this.newArr.filter((item: any) => item.id == 5);

    this.newArr2.forEach((x: any) => {

      if (x.ParentId == Id) {

        this.check2.push(x);


      }

    });



  }


  getCourseamtList(amt:any) {
    debugger

    if (amt == 'Remove Filter') {
      location.reload();
      return;
    }

    var price = {
      "Price": parseFloat(amt)
    };

    this.authService.getProductByPrice(price).subscribe((x1: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger;


      if (x1.apiStatus == true) {
        this.name = null;
        this.serviceList = null;
        this.pages = [];
        this.newArr = null;

        this.name = x1.apiData;

        this.name.forEach((x: any) => {
          debugger;
          if (x.ParentId == null) {

            var data = this.name.filter((item: any) => item.Id == x.Id);

            this.serviceList = data[0]["SubCategories"];

            this.pages.push(this.serviceList);

            this.newArr = this.pages.flat(1);

            this.newArr.filter((item: any) => item.ParentId == x.Id);

          }

        });
      }
      else {
        this.toastr.success(x1.apiMessage, 'Info');
      }
    },
      (err: { error: string | undefined; }) => {
        this.toastr.error(err.error, 'Error');
      }
    );
  }

  getCatgories() {

    this.authService.GetCategoryList().subscribe((x1: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger;
      if (x1.apiStatus == true) {



        /// alert(1);
        ;
        this.name = x1.apiData;

        this.name.forEach((x: any) => {
          debugger;
          if (x.ParentId == null) {

            var data = this.name.filter((item: any) => item.Id == x.Id);

            this.serviceList = data[0]["SubCategories"];

            this.pages.push(this.serviceList);

            this.newArr = this.pages.flat(1);

            this.newArr.filter((item: any) => item.ParentId == x.Id);

          }

        });
      }
      else {
        this.toastr.success(x1.apiMessage, 'Info');
      }
    },
      (err: { error: string | undefined; }) => {
        this.toastr.error(err.error, 'Error');
      }
    );

  }




  sendserviceCode(val: any, serviceType: any, Code: any, id: any) {
    debugger
    if (serviceType == "1") {

      if (val == "AGV") {
        this.router.navigate(['/GiftVoucher'], { queryParams: { serviceCode: Code }, skipLocationChange: true });

        //  this.router.navigate(['/AddMoney']);
      }
      else {

        this.router.navigate(['/CourseContent'], { queryParams: { serviceCode: id }, skipLocationChange: true });
      }
      //else if (val == "ETE") {

      //  this.router.navigate(['/PayMoney'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
      //}

      //else if (val == "VPR") {

      //  this.router.navigate(['/ViewPaymentRequest'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
      //}
      //else if (val == "SCP") {

      //  this.router.navigate(['/ShowCode'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
      //}


    }
    //else if (serviceType == "2") {
    //  if (val == "AIR") {
    //    //[routerLink] = "['/Manageuser/UploadDocument',d?.emailID,d?.walletUserId]"
    //    this.router.navigate(['/Airtime'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "MMP") {
    //    //[routerLink] = "['/Manageuser/UploadDocument',d?.emailID,d?.walletUserId]"
    //    this.router.navigate(['/TransferToMobileMoney'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "IMR") {

    //    this.router.navigate(['/InternationalMobileRecharge'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "IDR") {

    //    this.router.navigate(['/InternationalDTH'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }

    //  else if (val == "ZIS") {

    //    this.router.navigate(['/Internet'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "ZTR") {

    //    this.router.navigate(['/Travel'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }

    //  else if (val == "ZTV") {

    //    this.router.navigate(['/Tv'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "ZPB") {

    //    this.router.navigate(['/Bill'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "MEE") {

    //    this.router.navigate(['/DirectPayCompanies'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "XBT") {

    //    this.router.navigate(['/Xbet'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "TTB") {

    //    this.router.navigate(['/Transfertobank'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }
    //  else if (val == "TBN") {

    //    this.router.navigate(['/BankTransferNigeriaUSD'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }

    //  else if (val == "KNT") {

    //    this.router.navigate(['/KorapayBankTransferNigeria'], { queryParams: { serviceCode: serviceCode }, skipLocationChange: true });
    //  }



    //}

  }







}
